import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker'
import dayjs from 'dayjs'
import { useState } from 'react'

export const useDateRangePicker = customFormatting => {
    const [dateRangeValue, setDateRangeValue] = useState<DateRange<any>>([null, null])
    const [dateRangeStart, dateRangeEnd] = dateRangeValue
    const handleDateRangeValue = (newValue: DateRange<any>) => {
        setDateRangeValue(newValue)
    }
    return {
        dateRangeValue,
        handleDateRangeValue,
        dateRangeStart: !!dateRangeStart ? dayjs(dateRangeStart).format(customFormatting) : null,
        dateRangeEnd: !!dateRangeEnd ? dayjs(dateRangeEnd).format(customFormatting) : null,
    }
}
